module.exports = __webpack_public_path__ + "static/img/rating-A.2dbf2b5.png";